import type { Validator } from './types';

export function makeRegExpValidator(re: RegExp, message: string): Validator<string> {
    return (value?: string) => (!value || re.test(value) ? undefined : message);
}
